import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import CullReport from '../../Pages/Report/CullReport/CullReport'
import WeaningReport from '../../Pages/Report/WeaningReport/WeaningReport'
import OldLinesReport from '../../Pages/Report/OldLinesReport/OldLinesReport'
import BPLitterReport from '../../Pages/Report/BPLitter/BPLitterReport'
import RenderMessage from '../../garvan-react/Components/ModalFeedback/RenderMessage'
import ShippingManifestReport from '../../Pages/Report/ShippingManifest/ShippingManifestReport'
import PageSection from '../../Constants&Theme/PageSection'

function ReportRouter() {
  return (
    <Routes>
      <Route
        index
        element={
          <PageSection title={'Reports'}>
            <RenderMessage
              message={{
                subject: 'No report selected',
                message: 'Please select a report from the menu on the left',
                severity: 'warning',
                loading: false,
              }}
            />
          </PageSection>
        }
      />
      <Route
        path="*"
        element={
          <RenderMessage
            message={{
              message: 'Please select a report from the menu on the left',
              subject: 'Report not found',
              severity: 'warning',
              loading: false,
            }}
          />
        }
      />
      <Route
        path="cull"
        element={<CullReport />}
      />
      <Route
        path="weaning"
        element={<WeaningReport />}
      />
      <Route
        path="old-lines"
        element={<OldLinesReport />}
      />
      <Route
        path="bp"
        element={<BPLitterReport />}
      />
      <Route
        path="shipping-manifest"
        element={<ShippingManifestReport />}
      />
    </Routes>
  )
}

export default ReportRouter
